module.exports = __webpack_public_path__ + "static/media/alert_warning.ba269ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/alert_warning.svg
// module id = 820
// module chunks = 0